module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "FMH"
  }, [_vm._v("PRINCIPAL CHARACTERS")]), _vm._v(" "), _c('p', {
    staticClass: "FMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE SPANISH")])]), _vm._v(" "), _c('p', {
    staticClass: "FMH2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("For the government (also known as Republicans, Loyalists)")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Julio Álvarez del Vayo, foreign minister of the Spanish Republic, September 1936–May 1937 and April 1938–March 1939")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Arturo Barea Ogazón, patent engineer, press censor, would-be writer")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Luís Companys, president of the Generalitat (autonomous government) of Catalonia")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Francisco Largo Caballero, Socialist leader, prime minister of the Spanish Republic, September 1936–May 1937")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Enrique Líster, Soviet-trained commander of the 11th Division of the Popular Army, later of the 5th Army Corps")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("José Miaja, Loyalist general and chief of the Defense Junta of Madrid")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Colonel Juan Modesto, Communist commander of the Fifth Army Corps, later of the Army of the Ebro")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Constancia de la Mora y Maura, aristocrat, Communist, deputy (from May 1937) and then propaganda chief of the Spanish Republic, October 1937–February 1939")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Dr. Juan Negrín, Socialist leader, finance minister, and later prime minister of Spain, May 1937–March 1939")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Andrés Nin, anti-Stalinist Catalan communist, founder of the POUM")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Indalecio Prieto, socialist leader, rival of Largo Caballero, Spanish minister of defense, May 1937–March 1938")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("José Robles Pazos, Spanish translator of John Dos Passos")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Luis Rubio Hidalgo, propaganda minister of the Spanish Republic, September 1936–October 1937")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("José (Pepe) Quintanilla, chief of Madrid’s secret police, brother of the artist Luis Quintanilla")]), _vm._v(" "), _c('p', {
    staticClass: "FMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("For the rebels (also known as the Nationalists)")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Luis Bolín, right-wing conspirator, later Nationalist propaganda chief")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Francisco Franco Bahamonde, youngest general in the Spanish Army, later leader of the Nationalist rebellion")]), _vm._v(" "), _c('p', {
    staticClass: "FMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE AMERICANS")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Virginia (Ginny) Cowles, Hearst newspaper syndicate correspondent")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("John Dos Passos, novelist and journalist")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Sidney Franklin, American matador, friend and factotum to Ernest Hemingway")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Martha Gellhorn, novelist and journalist")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Ernest Hemingway, novelist and journalist")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Josephine (Josie) Herbst, American novelist and leftist journalist, friend of Hemingway and Dos Passos")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("James Lardner, American journalist, correspondent for the Paris bureau of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Herald-Tribune")]), _vm._v(", son of the American novelist Ring Lardner")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Archibald MacLeish, American poet and magazine editor, friend of Hemingway and Dos Passos")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Herbert L. Matthews, Madrid correspondent for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The New York Times")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Robert Hale Merriman, American professor of economics, commander of the Abraham Lincoln Battalion, later chief of staff of the Fifteenth International Brigade")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Maxwell Perkins, Hemingway’s editor at Charles Scribner’s Sons")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Liston Oak, American Communist working for the Spanish Republican Propaganda Ministry; secretary of the League of American Writers")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Franklin Roosevelt, president of the United States of America, 1933–1945")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Eleanor Roosevelt, his wife, journalist and activist")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Vincent (Jimmy) Sheean, foreign correspondent of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Herald-Tribune")])]), _vm._v(" "), _c('p', {
    staticClass: "FMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE BRITISH")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Eric Blair, a.k.a. George Orwell, English investigative journalist and POUM militiaman")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Claud Cockburn, Spanish correspondent for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Daily Worker")]), _vm._v(", editor and correspondent for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Week")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Sefton (Tom) Delmer, Madrid correspondent for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Daily Express")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Diana (Dinah) Forbes-Robertson, a writer, married to Vincent Sheean")]), _vm._v(" "), _c('p', {
    staticClass: "FMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE RUSSIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Vladimir Gorev, special military attaché of the Soviet Union and Madrid station chief of the GRU (Soviet military intelligence)")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("General Emilio Kléber, a.k.a. Manfred (or Lazar) Stern, commander of the Eleventh International Brigade, November 1936")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Mikhail Koltsov, Russian journalist, Spanish correspondent for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Pravda")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Alexander Orlov, NKVD station chief in Madrid (later Valencia), 1936–1938")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Joseph Vissarionovich Stalin, general secretary of the Communist Party, 1922–1952")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Marshal Kliment Voroshilov, people’s commissar for defense, USSR")]), _vm._v(" "), _c('p', {
    staticClass: "FMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE OTHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Ted Allan, leftist Canadian journalist")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("André (Endre) Friedmann, a.k.a. Robert Capa, Hungarian photographer")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Carlos Contreras, a.k.a. Vittorio Vidali, Trieste-born NKVD agent and founder of the Loyalist Fifth Regiment")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Louis Delaprée, Madrid correspondent for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Paris-Soir")])]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("John Ferno, a.k.a. Fernhout, Dutch Communist cinematographer")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Joris Ivens, Dutch Communist film director")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Colonel Hans Kahle, exiled Prussian Communist, after 1936 commander of the Eleventh International Brigade, later divisional commander in the Republican Popular Army")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Alfred Kantorowicz, Polish émigré journalist, information officer of the Chapaiev Battalion of the Thirteenth International Brigade")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Geza Korvin Karpathi, Hungarian photographer and filmmaker, boyhood friend of Endre Friedmann (Robert Capa)")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Otto Katz, a.k.a. André Simone, refugee German Communist, propagandist, founder of the Agence Espagne")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Ilse (later Ilsa) Kulcsar, née Pollak, Austrian journalist, socialist activist, and translator")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Leopold (Poldi) Kulcsar, Austrian journalist and clandestine political operative")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("General Pavol Lukács, a.k.a. Maté Zalka, Hungarian-born, Moscow-trained commander of the Twelfth International Brigade")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("André Malraux, French novelist, art theorist, founder of the Escuadrilla España")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Randalfo Pacciardi, Italian antifascist, commander of the Garibaldi Battalion of the Twelfth International Brigade")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Gustav Regler, German Communist refugee, political commissar of the Twelfth International Brigade")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Kajsa Rothman, Swedish guide and interpreter employed by the Loyalist propaganda department")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Karol Swierczewski, a.k.a. Colonel [sometimes General] Walter, Polish-born, Soviet-trained commander of the Fourteenth International Brigade")]), _vm._v(" "), _c('p', {
    staticClass: "FMUL"
  }, [_vm._v("Gerta Pohorylle, a.k.a. Gerda Taro, Polish-born German photographer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1773ef96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/principalcharacters.vue
// module id = 78
// module chunks = 0